import {ReactComponent as DrainageIcon} from "../../images/layout/drainage.svg";
import Icon from "@ant-design/icons";
import React from "react";
import {Path} from "../public/path";
import {ReactComponent as FissionIcon} from "../../images/layout/nav_fission.svg";
import {ReactComponent as MarketIcon} from "../../images/layout/nav_market.svg";
import {ReactComponent as CustomerIcon} from "../../images/layout/nav_customer.svg";
import {ReactComponent as AssertIcon} from "../../images/layout/nav_assert.svg";
import {ReactComponent as MarketSettingIcon} from "../../images/layout/nav_market_setting_1.svg";
import {ReactComponent as AccountIcon} from "../../images/cloud/layout/nav_account.svg";
import CloudPath from "../cloud/cloud_path";
import {ReactComponent as FriendIcon} from "../../images/cloud/layout/nav_friend.svg";
import {ReactComponent as CustomerTouchIcon} from "../../images/cloud/layout/nav_customer_touch.svg";
import {ReactComponent as GroupChatIcon} from "../../images/cloud/layout/nav_groupchat.svg";

global.permissionConf={
    wxworkHelper: [{
        key: "wxworkHelper",
        checked: 1,
        submenu: [{
            key: "drainage",
            checked:  1,
            submenu:[{
                key: "drainage_channelqr",
                checked:  1,
            }]
        },{
            key: "fission",
            checked:  1,
            submenu:[{
                key: "fission_customer",
                checked:  1,
            },{
                key: "fission_chat",
                checked:  1,
            },{
                key: "fission_redpacket",
                checked:  1,
            },{
                key: "fission_groupRed",
                checked:  1,
            },{
                key: "fission_lottery",
                checked:  1,
            }]
        },{
            key: "market",
            checked:  1,
            submenu: [{
                key: "market_distri",
                checked:  1,
            },{
                key: "market_groupbuy",
                checked:  1,
            },{
                key: "market_prizeunlock",
                checked:  1,
            },{
                key: "market_from",
                checked:  1,
            },{
                key: "market_redeemcode",
                checked:  1,
            },{
                key: "market_verifier",
                checked:  1,
            },{
                key: "market_batchdeliver",
                checked:  1,
            }]
        },{
            key: "customer",
            checked:  1,
            submenu: [{
                key: "customer_manage",
                checked:  1,
            },{
                key: "customer_blackList",
                checked:  1,
            },{
                key: "customer_tag",
                checked:  1,
            }]
        },{
            key: "marketAssert",
            checked:  1,
            submenu: [{
                key: "marketAssert_overview",
                checked:  1,
            },{
                key: "marketAssert_settle",
                checked:  1,
            },{
                key: "marketAssert_withdraws",
                checked:  1,
            },{
                key: "marketAssert_statements",
                checked:  1,
            },{
                key: "marketAssert_summary",
                checked:  1,
            }]
        },{
            key: "marketSetting",
            checked:  1,
            submenu: [{
                key: "marketSetting_brand",
                checked:  1,
            },{
                key: "marketSetting_mp",
                checked:  1,
            },{
                key: "marketSetting_wxpay",
                checked:  1,
            },{
                key: "marketSetting_corpManage",
                checked:  1,
            },{
                key: "marketSetting_member",
                checked:  1,
            }]
        }]
    }],
    wxworkHelperPro: [{
        key: "wxworkHelperPro",
        checked:  1,
        submenu: [{
            key: "account",
            checked:  1,
            submenu:[{
                key: "account_seat",
                checked:  1,
            },{
                key: "account_chat",
                checked:  1,
            },{
                key: "account_talkLib",
                checked:  1,
            },]
        },{
            key: "drainage",
            checked:  1,
            submenu:[{
                key: "drainage_mobilefriend",
                checked:  1,
            },{
                key: "drainage_groupchatfriend",
                checked:  1,
            },{
                key: "drainage_autoThroughFriend",
                checked:  1,
            },]
        },{
            key: "friend",
            checked:  1,
            submenu:[{
                key:'friend_cust-operation',
                checked: 1,
            },{
                key: "friend_autoRemark",
                checked:  1,
            },{
                key: "friend_oneway-friend",
                checked:  1,
            }]
        },{
            key: "market",
            checked:  1,
            submenu:[{
                key: "market_keyword",
                checked:  1,
            },{
                key: "market_groupsend",
                checked:  1,
            },{
                key: "market_customerSOP",
                checked:  1,
            },{
                key: "market_groupSOP",
                checked:  1,
            },{
                key: "market_my_soptemplate",
                checked:  1,
            },{
                key: "market_material",
                checked:  1,
            }]
        },{
            key: "customer",
            checked:  1,
            submenu:[{
                key: "customer_groupchat_manage",
                checked:  1,
            },{
                key: "customer_groupchat_tag",
                checked:  1,
            },{
                key: "customer_roomwelmsg",
                checked:  1,
            },{
                key: "customer_rlivecode",
                checked:  1,
            },{
                key: "customer_notice",
                checked:  1,
            },{
                key: "customer_kwpullgroup",
                checked:  1,
            },{
                key: "customer_autoinvite",
                checked:  1,
            },{
                key: "customer_errorcheck",
                checked:  1,
            },{
                key: "customer_blacklistPro",
                checked:  1,
            },{
                key: "customer_whitelist",
                checked:  1,
            }]
        }]
    }]
}
global.wxworkHelper={
    'wxworkHelper':{
        title:'企微助手'
    },
    'drainage':{
        title:'引流获客',
        icon:< Icon component={DrainageIcon}/>
    },
    'drainage_channelqr':{
        title:'渠道活码',
        path: Path.getChannelCodeWords(),
        pathIn: Path.isFissionChannel
    },
    'fission':{
      title:'裂变获客',
      icon: < Icon component={FissionIcon}/>
    },
    'fission_customer':{
        title:'客户裂变',
        path: Path.getFissionCustomer(),
        pathIn: Path.isFissionCustomer
    },
    'fission_chat':{
        title:'社群裂变',
        path: Path.getFissionChat(),
        pathIn: Path.isFissionChat
    },
    'fission_redpacket':{
        title: '红包获客',
        path: Path.getFissionRedpacket(),
        pathIn: Path.isFissionRedpacket
    },
    'fission_groupRed':{
        title: '红包扩群',
        path: Path.getFissionGroupRed(),
        pathIn: Path.isFissionGroupRed
    },
    'fission_lottery':{
        title: '抽奖裂变',
        path: Path.getFissionLottery(),
        pathIn: Path.isFissionLottery
    },
    'market':{
        title: '营销中心',
        icon: < Icon component={MarketIcon}/>
    },
    'market_distri':{
        title: '分销系统',
        path: Path.getMarketDistri(),
        pathIn: Path.isMarketDistri
    },
    'market_groupbuy':{
        title: '拼团系统',
        path: Path.getMarketGroupbuy(),
        pathIn: Path.isMarketGroupbuy
    },
    'market_prizeunlock':{
        title: '一元解锁',
        path: Path.getMarketPrizeUnlock(),
        pathIn: Path.isMarketPrizeUnlock
    },
    'market_from':{
        title: '表单管理',
        path: Path.getMarketForm(),
        pathIn: Path.isMarketForm
    },
    'market_redeemcode':{
        title: '兑换码',
        path: Path.getMarketRedeemCode(),
        pathIn: Path.isMarketRedeemCode
    },
    'market_verifier':{
        title: '核销管理',
        path: Path.getMarketVerifier(),
        pathIn: Path.isMarketVerifier
    },
    'market_batchdeliver':{
        title:'批量发货',
        path: Path.getBatchDeliver(),
        pathIn: Path.isGetBatchDeliver
    },
    'customer':{
        title: '客户管理',
        icon: < Icon component={CustomerIcon}/>
    },
    'customer_manage':{
        title: '客户管理',
        path: Path.geCustomerMange(),
        pathIn: Path.isCustomerMange
    },
    'customer_blackList':{
        title: '黑名单',
        path: Path.getCustomerBlackList(),
        pathIn: Path.isCustomerBlackList
    },
    'customer_tag':{
        title: '客户标签',
        path: Path.getCustomerTag(),
        pathIn: Path.isCustomerTag
    },
    'marketAssert':{
        title: '资产管理',
        icon: < Icon component={AssertIcon}/>
    },
    'marketAssert_overview':{
        title: '我的账户',
        path: Path.goMarketAssets(),
        pathIn: Path.isMarketAssets
    },
    'marketAssert_settle':{
        title: '结算记录',
        path: Path.gotoAssetSettle() + 1,
        pathIn: Path.isMarketAssetsSettle
    },
    'marketAssert_withdraws':{
        title: '提现管理',
        path: Path.goMarketAssetsWithdraws(),
        pathIn: Path.isMarketAssetsWithdraws
    },
    'marketAssert_statements':{
        title: '账单明细',
        path: Path.goMarketAssetsStatements(),
        pathIn: Path.isMarketAssetsStatements
    },
    'marketAssert_summary':{
        title: '日对账单',
        path: Path.goMarketAssetsSummary(),
        pathIn: Path.isMarketAssetsSummary
    },
    'marketSetting':{
        title: '配置管理',
        icon: < Icon component={MarketSettingIcon}/>
    },
    'marketSetting_brand':{
        title: '营销配置',
        path: Path.getMarketConfigBrand(),
        pathIn: Path.isMarketConfig
    },
    'marketSetting_mp':{
        title: '公众号',
        path: Path.getMpConfig(),
        pathIn: Path.isMpConfig
    },
    'marketSetting_wxpay':{
        title: '支付配置',
        path: Path.getWxPayConfig(),
        pathIn: Path.isWxPayConfig
    },
    'marketSetting_corpManage':{
        title: '企业微信',
        path: Path.getCorpManageConfig(),
        pathIn: Path.isCorpManageConfig
    },
    'marketSetting_member':{
        title: '成员管理',
        path: Path.getMemberConfig(),
        pathIn: Path.isMemberConfig
    }
}
global.wxworkHelperPro={
    'wxworkHelperPro':{
        title:'企微助手Pro'
    },
    'account':{
        title: '账号运营',
        icon: < Icon component={AccountIcon}/>,
    },
    'account_seat':{
        title: '账号管理',
        path: CloudPath.getSeatPath(),
        pathIn: CloudPath.isSeatPath
    },
    'account_chat':{
        title: '聚合聊天',
        path: CloudPath.getImChat(),
        pathIn: CloudPath.isImChat,
        link: true
    },
    'account_talkLib':{
        title: '话术库',
        path: CloudPath.getTalklibPath(),
        pathIn: CloudPath.isSeatTalklibPath
    },
    'drainage':{
        title: '拓客引流',
        icon: < Icon component={DrainageIcon}/>
    },
    'drainage_mobilefriend':{
        title: '手机号加好友',
        path: CloudPath.getMobileFriend(),
        pathIn: CloudPath.isMobileFriend
    },
    'drainage_groupchatfriend':{
        title: '群加好友',
        path: CloudPath.getGroupChatFriend(),
        pathIn: CloudPath.isGroupChatFriend
    },
    'drainage_autoThroughFriend':{
        title: '接受新客户',
        path: CloudPath.newFriendRequest(),
        pathIn: CloudPath.isNewFriendRequest
    },
    'friend':{
        title: '客户运营',
        icon: < Icon component={FriendIcon}/>
    },
    'friend_cust-operation':{
        title: '客户管理',
        path: CloudPath.getCustOperationManageList(),
        pathIn: CloudPath.isCustOperationManagePath
    },
    'friend_autoRemark':{
        title: '新客户运营',
        path: CloudPath.newFriendRemark(),
        pathIn: CloudPath.isNewFriendRemark
    },
    'friend_oneway-friend':{
        title: '单向好友',
        path: CloudPath.getOneWayFriendPath(),
        pathIn: CloudPath.isOneWayFriendPath
    },
    'market':{
        title: '客户触达',
        icon: < Icon component={CustomerTouchIcon}/>
    },
    'market_keyword':{
        title: '智能回复',
        path: CloudPath.getCloudKeyword(),
        pathIn: CloudPath.isCloudKeyword
    },
    'market_groupsend':{
        title: '消息群发',
        path: CloudPath.getCloudFriendGroupsend(),
        pathIn: CloudPath.isCloudFriendGroupsend
    },
    'market_customerSOP':{
        title: '客户SOP',
        path: CloudPath.getCustomerSop(),
        pathIn: CloudPath.isCustomerSop
    },
    'market_groupSOP':{
        title: '群聊SOP',
        path: CloudPath.getGroupSop(),
        pathIn: CloudPath.isGroupSop
    },
    'market_my_soptemplate':{
        title: 'SOP模板',
        path: CloudPath.getCustomerSopTemplate(),
        pathIn: CloudPath.isCustomerSopTemplate
    },
    'market_material':{
        title: '素材库',
        path: CloudPath.getCustomerMaterial(),
        pathIn: CloudPath.isCustomerMaterial
    },
    'customer':{
        title: '高效社群',
        icon: < Icon component={GroupChatIcon}/>
    },
    'customer_groupchat_manage':{
        title: '群聊管理',
        path: CloudPath.getGroupChatManage(),
        pathIn: CloudPath.isGroupChatManage
    },
    'customer_groupchat_tag':{
        title: '群聊标签',
        path: CloudPath.getGroupChatTagList(),
        pathIn: CloudPath.isGroupChatTagList
    },
    'customer_roomwelmsg':{
        title: '入群欢迎语',
        path: CloudPath.getGroupChatRoomWelMsg(),
        pathIn: CloudPath.isGroupChatRoomWelMsg
    },
    'customer_rlivecode':{
        title: '群活码',
        path: CloudPath.getGroupChatLivecode(),
        pathIn: CloudPath.isGroupChatLivecode
    },
    'customer_notice':{
        title: '群发公告',
        path: CloudPath.getGroupChatNotice(),
        pathIn: CloudPath.isGrouChatNotic
    },
    'customer_kwpullgroup':{
        title: '关键词拉群',
        path: CloudPath.getGroupChatKWPullGroup(),
        pathIn: CloudPath.isGroupChatKWPullGroup
    },
    'customer_autoinvite':{
        title: '高级拉群',
        path: CloudPath.getAutoInvite(),
        pathIn: CloudPath.isAutoInvite
    },
    'customer_errorcheck':{
        title: '群聊质检',
        path: CloudPath.getGroupChatCloudErrorCheck(),
        pathIn: CloudPath.isCloudGroupChatErrorCheck
    },
    'customer_blacklistPro':{
        title: '黑名单',
        path: CloudPath.getBlackList(),
        pathIn: CloudPath.isBlackList
    },
    'customer_whitelist':{
        title: '白名单',
        path: CloudPath.getWhiteList(),
        pathIn: CloudPath.isWhiteList
    }
}